import React from "react";
import { Skeleton, Box, Card, Grid, Stack } from "@mui/material";

export default function PaymentHistorySkeleton() {
  return (
    <Box sx={{ width: "100%" }}>
      {/* ================= SUMMARY CARDS ================= */}
      <Box sx={{ mb: 4 }}>
        <Grid container spacing={3}>
          {[1, 2, 3].map((item) => (
            <Grid  xs={12} md={4} key={item}>
              <Card sx={{ p: 3 }}>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Skeleton variant="circular" width={48} height={48} />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton variant="text" width="60%" height={20} />
                    <Skeleton variant="text" width="40%" height={28} />
                  </Box>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* ================= PAGE HEADER ================= */}
      <Box sx={{ mb: 3 }}>
        <Skeleton variant="text" width={240} height={36} />
        <Skeleton variant="text" width={420} height={22} />
      </Box>

      {/* ================= FILTERS ================= */}
      <Card sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid  xs={12} md={4}>
            <Skeleton variant="text" width={100} />
            <Skeleton variant="rectangular" height={42} />
          </Grid>

          <Grid  xs={12} md={4}>
            <Skeleton variant="text" width={120} />
            <Skeleton variant="rectangular" height={42} />
          </Grid>

          <Grid  xs={12} md={4} alignSelf="flex-end">
            <Skeleton variant="rectangular" height={42} />
          </Grid>
        </Grid>
      </Card>

      {/* ================= TRANSACTION LIST ================= */}
      <Stack spacing={3}>
        {[1, 2, 3, 4].map((item) => (
          <Card key={item} sx={{ p: 3 }}>
            <Grid container spacing={2} alignItems="center">
            
              <Grid >
                <Skeleton variant="circular" width={40} height={40} />
              </Grid>

          
              <Grid  xs={12} md={7}>
                <Skeleton variant="text" width="60%" height={22} />
                <Skeleton variant="text" width="80%" height={18} />
                <Skeleton variant="text" width="50%" height={18} />
              </Grid>

             
              <Grid  xs={12} md={3}>
                <Skeleton variant="text" width="70%" height={20} />
                <Skeleton variant="rectangular" width={36} height={36} />
              </Grid>
            </Grid>
          </Card>
        ))}
      </Stack>
    </Box>
  );
}
